import { useLayoutEffect, useRef } from "react";
import "pop-up-pattern/dist/foundation.css";
import 'styleguide/dist/styleguide-index-ds2.css'
import "./PopUp.css"

import infoCircleSolidSmall from "styleguide/icons/ds2/infocirclesolidsmall.svg";
import infoCircleSmallOutline from "styleguide/icons/ds2/info-circle-small-outline.svg";
import { popUpInit } from "pop-up-pattern/src/pop-up-ds2";

export type DropdownProps = {
  label?: string; // 👈 label text
  placement?: string;
  headerText?: string;
  message: string;
  className?: string;
};


const PopUp:  React.FC<DropdownProps> = ({
  placement = "top",
  headerText = " ",
  message = "",
  className = "",
}) => {
  const rootRef = useRef<HTMLSpanElement | null>(null);

  useLayoutEffect(() => {
    popUpInit();

    // after popUpInit creates the internal trigger/button, wire hover handlers
    const root = rootRef.current;
    if (!root) return;
    const trigger = root.querySelector<HTMLElement>('.pop-up-trigger');
    const dialog = root.querySelector<HTMLElement>('.pop-up-dialog');
    if (!trigger || !dialog) return;

    const onEnter = () => {
      if (!dialog.classList.contains('open')) trigger.click();
    };
    const onLeave = () => {
      if (dialog.classList.contains('open')) trigger.click();
    };

    trigger.addEventListener('mouseenter', onEnter);
    root.addEventListener('mouseleave', onLeave);

    return () => {
      trigger.removeEventListener('mouseenter', onEnter);
      root.removeEventListener('mouseleave', onLeave);
    };
  }, []);

  return (
    <span
      className={`ds-pop-up ${className}`}
      ref={rootRef}
      data-ds-theme="vessel"
      data-ds-version="2"
      data-ds-variant="basic"
      data-popup-trigger="hover"
      data-popup-body={message}
      data-popup-type="icon"
      data-popup-placement={placement}
      data-popup-icon-default={infoCircleSmallOutline}
      data-popup-icon-active={infoCircleSolidSmall}
      data-popup-header={headerText}
    ></span>
  );
};

export default PopUp;
